export const listBuilderTheme = (theme) => ({
  dropZoneShadow: '0 0 3pt 2pt #37939B',
  contentFontFamily: theme?.typography?.fontFamily,
  listBorderColor: theme?.palette?.grey.G200,
  backgroundColor: theme?.palette?.background,
  hoverBackgroundColor: '#CBE4FF',
  dragBackgroundColor: theme?.palette?.primary.normal,
  buttonBackgroundColor: theme?.palette?.primary.normal,
  buttonHoverBackgroundColor: theme?.palette?.primary.normal,
  dragColor: theme?.palette?.text.light,
  wrapBorder: `1px solid ${theme?.palette?.grey.G200}`,
  itemPadding: 20,
  transition: theme?.transitions?.easing.easeInOut,
  title: {
    textTransform: 'uppercase',
    fontFamily: '"Roboto Condensed", sans-serif'
  },
  icon: {},
  items: {
    borderLeft: 'none',
    borderRight: 'none'
  },
  item: {
    minHeight: 60,
    borderBottom: `1px solid ${theme?.palette?.accent}`,
    '&:last-child': {
      borderBottom: 'none'
    },
    '& > label > input[type="checkbox"] + div > svg': {
      background: theme?.palette?.background,
      borderRadius: 2
    },
    '& > label > input[type="checkbox"]:checked + div svg': {
      fill: theme?.palette?.background
    }
  },
  dragIcon: {
    opacity: ({ dragging }) => (dragging ? 1 : 0),
    '& svg': {
      fill: ({ dragging }) => dragging && theme?.palette?.background
    }
  }
});

export default listBuilderTheme;
